<template>
  <div>
    <b-card title="Vous pouvez rechercher les devis directement ici.">
      <b-row>
        <b-col
          cols="12 mb-4"
        >
          <div class="px-2 py-1 navbar-light header-navbar rounded-lg shadow d-flex align-items-center justify-content-start">
            <feather-icon
              icon="SearchIcon"
              class="mr-50 text-primary"
              size="20"
            />
            <b-input-group class="input-group-merge shadow-none">
              <b-form-input
                v-model="code"
                placeholder="Rechercher un devis..."
                style="height: auto;"
                class="border-0 shadow-none"
                @input="filter"
              />
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <div
        v-if="loading"
        class="d-flex justify-content-center mb-1"
      >
        <b-spinner label="Loading..." />
      </div>
      <b-row v-else class="match-height">
        <b-table
          ref="selectableTable"
          selectable
          :items="quotations"
          :fields="fields"
        >
          <!-- <template #cell(show_details)="data">
            <b-form-checkbox
              v-model="data.detailsShowing"
              plain
              class="vs-checkbox-con"
              @change="data.toggleDetails"
            >
              <span class="vs-checkbox">
                <span class="vs-checkbox--check">
                  <i class="vs-icon feather icon-check" />
                </span>
              </span>
              <span class="vs-label">{{ data.detailsShowing ? 'Cacher' : 'Voir' }}</span>
            </b-form-checkbox>
          </template> -->

          <template #cell(_createdAt)="data">
            {{ $moment(data.item._createdAt).format('DD/MM/YYYY') }}
          </template>
          <template #cell(_updatedAt)="data">
            {{ $moment(data.item._updatedAt).format('DD/MM/YYYY') }}
          </template>
          <template #cell(order.form.shipping.first_name)="data">
            <p>{{ data.item.order.form.shipping.first_name }} {{ data.item.order.form.shipping.last_name }}</p>
            <p>{{ data.item.order.form.shipping.email }}</p>
            <p>{{ data.item.order.form.shipping.phone }}</p>
          </template>
          <template #cell(number)="data">
            <a :href="data.item.url">{{ data.item.number }}</a>
            <b-badge v-if="data.item._user" variant="light-primary">
              <span class="align-middle">{{ data.item._user.firstName }} {{  data.item._user.lastName }}</span>
            </b-badge>
          </template>
          <template #cell(status)="data">
            <v-select
              v-model="data.item.status"
              placeholder="Statut"
              label="boutique"
              :clearable="false"
              :options="['ENVOYE', 'VALIDE', 'REFUSE', 'RELANCE 1', 'RELANCE 2', 'RELANCE 3', 'SANS REPONSE']"
              @input="updateDevis(data.item)"
            />
          </template>
          <template #cell(order.price)="data">
            {{ data.item.order.price }}€
          </template>
        </b-table>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BSpinner,
  BFormInput,
  BTable,
  BBadge,
  VBPopover,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormInput,
    BCard,
    BSpinner,
    BRow,
    BCol,
    BTable,
    BBadge,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContentVue,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      required,
      baseQuotations: [],
      quotations: [],
      products: [],
      categories: [],
      quotation: {},
      conditionalProducts: '',
      conditionalCategories: '',
      types: [{ name: 'Remise fixe', type: 'fixed_cart' }, { name: 'Remise en pourcentage', type: 'percent' }],
      individualType: [{ name: 'Oui', type: true }, { name: 'Non', type: false }],
      conditions: [{ name: 'OU', type: 'or' }, { name: 'ET', type: 'and' }],
      code: '',
      fields: [{ key: 'number', sortable: true }, { label: 'Crée le', key: '_createdAt', sortable: true }, { label: 'Last Update', key: '_updatedAt', sortable: true }, { label: 'Status', key: 'status' }, { label: 'Total', key: 'order.price' }, { label: 'Contact', key: 'order.form.shipping.first_name', sortable: true }],
      showModal: false,
      categoryInformations: [],
      loading: false,
    }
  },
  async mounted() {
    try {
      await this.getQuotations()
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    async getQuotations() {
      try {
        const {
          devis,
        } = await this.$http.get('/admin/devis')
        this.quotations = devis
        this.baseQuotations = devis
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    filter() {
      this.filterQuery = this.code
      if (!this.code || this.code === '') {
        this.quotations = this.baseQuotations
      } else {
        const value = this.code
        console.log(value)
        this.quotations = this.baseQuotations.filter(quotation => quotation.order.shipping.first_name?.toLowerCase().includes(value.toLowerCase()) || quotation.order.shipping.last_name?.toLowerCase().includes(value.toLowerCase()) || quotation.order.billing.email?.toLowerCase().includes(value.toLowerCase()))
      }
    },
    async updateDevis(item) {
      await this.$http.put(`/admin/devis/${item._id}`, { status: item.status })
    },
  },
}
</script>

<style>
 .jsoneditor-poweredBy {
   display: none;
 }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
